import './skip-to-content.css';
export default {
  "skipToContent": "pf-v5-c-skip-to-content"
};